import { useMemo } from 'react'
import { endOfMonth, isThisMonth } from 'date-fns'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { formatDate } from 'redesign/shared/date'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { newDateWithoutTime } from 'utils/date'
import type { UseBalanceTableContentProps } from './types'

export const useBalanceTableContent = ({ date, balance }: UseBalanceTableContentProps) => {
  const { t, locale } = useFavurTranslation()

  const endDate = formatDate({
    date: endOfMonth(date),
    dateFormat: DATE_FORMAT_VARIANTS.shortWithoutWeekday,
    locale,
    t,
    displayYear: false,
  })
  const isCurrentMonth = isThisMonth(date)
  const hasEstimations =
    Boolean(balance) && (Boolean(balance?.estimations?.vacation) || Boolean(balance?.estimations?.bankHoliday))
  const showEstimations = isCurrentMonth && hasEstimations
  const dateEndOfYear = showEstimations
    ? formatDate({
        date: newDateWithoutTime(balance?.estimationDate),
        dateFormat: DATE_FORMAT_VARIANTS.shortWithoutWeekday,
        locale,
        t,
        displayYear: false,
      })
    : ''

  const balanceRows = useMemo(
    () => [
      {
        title: t('absenceRequest.components.employeeSaldo.bankHoliday'),
        value: balance?.bankHoliday,
        estimation: balance?.estimations?.bankHoliday,
      },
      {
        title: t('absenceRequest.components.employeeSaldo.vacation'),
        value: balance?.vacation,
        estimation: balance?.estimations?.vacation,
      },
      {
        title: t('absenceRequest.components.employeeSaldo.free'),
        value: balance?.free,
        estimation: null,
      },
    ],
    [balance, t],
  )

  return {
    balanceRows,
    endDate,
    dateEndOfYear,
  }
}
